import { Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth-guard';
import { RoleGuard } from 'app/guards/role-guard';

// Define routes specific to the RD Manager role
export const CatiRoutes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import('@pages/cati/cati-dashboard/cati-dashboard').then(
        (m) => m.CatiDashboard
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
    },
  },
];
